<template>
  <div class="PaymentReport">
    <b-card>
      <b-container fluid>
        <!-- User Interface controls -->
        <b-row align-v="center" align-h="between">
          <b-col sm="6" md="5" cols="10" lg="5" class="my-1">
            <b-form-group
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
              class="mb-0"
            >
              <b-input-group size="md">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Buscar"
                ></b-form-input>
                <!-- <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                    >X</b-button
                  >
                </b-input-group-append> -->
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="6" md="7" cols="12" lg="5" class="my-1">
            <b-form-group
              label="Por Página"
              label-cols-sm="6"
              label-cols-md="3"
              label-cols-lg="4"
              label-align-sm="right"
              label-size="sm"
              label-for="perPageSelect"
              class="mb-0"
            >
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="md"
                :options="pageOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Main table element -->
        <b-table
          show-empty
          small
          stacked="md"
          class="text-left"
          style="font-family: Montserrat; font-weight: lighter; font-size: 14px"
          id="my-table"
          :items="ReportsTmp"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          :busy="isBusy"
        >
          <template v-slot:empty>
            <div class="mt-2 text-center">
              <h6>No hay retiros realizados</h6>
            </div>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-dark my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Cargando...</strong>
            </div>
          </template>

          <template v-slot:emptyfiltered>
            <div class="my-2 text-center">
              <h6>No hay solicitudes con esas especificaciones</h6>
            </div>
          </template>
          <template v-slot:cell(amount)="row"> $ {{ row.value }} </template>
          <template v-slot:[`cell(transaction.status_payment_id)`]="row">
            <p v-if="row.value == 1">Pendiente</p>
            <p v-if="row.value == 2" style="color: green">
              Aprobado <v-icon name="check-circle"></v-icon>
            </p>
            <p v-if="row.value == 3" color="#CF173C">
              Rechazado <v-icon name="times-circle"></v-icon>
            </p>
            <!-- {{
            row.value == 1 ? "Pendiente" : row.value == 2 ? "Aprobada" : "Rechazada"
          }} -->
          </template>

          <template v-slot:cell(actions)="row">
            <b-button title="Detalles" size="sm" variant="white" @click="SelectReport(row.item)">
              <v-icon name="clipboard-list"></v-icon>
            </b-button>

            <b-button
              title="Aprobar"
              size="sm"
              variant="white"
              v-show="!progress"
              v-if="row.item.transaction.status_payment_id == 1"
              @click="changeStatus(row.item.account_transaction_id, 2)"
            >
              <v-icon name="check-circle" color="green"></v-icon>
            </b-button>
            <b-button
              title="Rechazar"
              size="sm"
              variant="white"
              v-show="!progress"
              v-if="row.item.transaction.status_payment_id == 1"
              @click="changeStatus(row.item.account_transaction_id, 3)"
            >
              <v-icon name="times-circle" color="#CF173C"></v-icon>
            </b-button>
            <b-spinner
                v-show="progress"
                small
                variant="primary"
                class="align-middle"
              ></b-spinner>
            <!-- <b-button
              title="Eliminar"
              size="sm"
              class="mr-1"
              variant="white"
              v-if="row.item.transaction.status_payment_id != 1"
              @click="deletePaymentReport(row.item)"
            >
              <v-icon v-show="!hide" name="trash" color="#CF173C"></v-icon>
              <b-spinner
                v-show="hide"
                small
                variant="danger"
                class="align-middle"
              ></b-spinner>
            </b-button> -->
          </template>
        </b-table>
        <b-col lg="5" class="mx-auto pt-2">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-container>
    </b-card>
    <b-modal
      id="modal-report"
      ref="modal"
      title-class="text-font-black"
      title="Datos del depósito"
      hide-footer
      size="lg"
      footer-class="text-font-black"
    >
      <b-container v-if="selected">
          <b-row>
            <b-col lg="6" >
              <b-form-group
                label="Nombre del usuario"
                label-class="text-light-black"
                label-for="last_name"

              >
               <p style="font-family: Montserrat; font-size: 14px">{{ selected.transaction.account.user.full_name }}</p>
              </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group
                label="Correo del usuario"
                label-class="text-light-black"
                label-for="last_name"

              >
               <p style="font-family: Montserrat; font-size: 14px"> {{ selected.transaction.account.user.email }} </p> 
              </b-form-group>
                
             
            </b-col>
            <b-col lg="6">
               <b-form-group
                label="Monto retirado"
                label-class="text-light-black"
                label-for="Email"

              >
                <p style="font-family: Montserrat; font-size: 14px">$ {{ selected.amount }} </p> 
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Correo del titular de la cuenta"
                label-class="text-light-black"
                label-for="last_name"
              >
               <p style="font-family: Montserrat; font-size: 14px"> {{ selected.transaction.bank.email }} </p> 
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Número de referencia"
                label-class="text-light-black"
                label-for="last_name"
              >
               <p style="font-family: Montserrat; font-size: 14px"> {{ selected.reference }} </p> 
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label="Comprobante"
                label-class="text-light-black"
                label-for="last_name"
                invalid-feedback="Apellido requerido"
              >
               <b-button
                style="border-radius: 12px; border: none"
                class="pl-5 pr-5 pt-2 pb-2 btn-card-color"
                size="sm"
                @click="OpenImg(selected.voucher)"
              >
                <span class="text-font-white">Ver comprobante</span>
              </b-button>
              </b-form-group>
            </b-col>
            
            <b-col lg="6" ></b-col>

            <b-col lg="3">
              
            </b-col>
            <b-col lg="3">
              <!-- <b-button
                style="border-radius: 12px; border: none"
                class="pl-5 pr-5 pt-2 pb-2"
                size="sm"
              >
                <span class="text-font-white">Cerrar</span>
              </b-button> -->
            </b-col>

            
          </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "PaymentReport",
  data() {
    return {
      progress: false,
      selected: null,
      hide: false,
      isBusy: false,
      ReportsTmp: [],
      PaymentReport: [],
      fields: [
        {
          key: "transaction.account.user.full_name",
          label: "Nombre",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "user_bank.name",
          label: "Banco titular",
          sortable: true,
        },
        
        {
          key: "amount",
          label: "Monto",
          sortable: true,
        },
        {
          key: "reference",
          label: "Referencia",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "payment_method.name",
          label: "Método de depósito",
          sortable: true,
        },
        {
          key: "date_payment",
          label: "Fecha",
          sortable: true,
        },
        {
          key: "transaction.status_payment_id",
          label: "Estado del depósito",
          sortable: true,
        },
        { key: "actions", label: "Acciones" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
    }),
  },
  mounted() {
    this.getDataReports();
  },
  methods: {
    ...mapActions([
      "GetPaymentReports",
      "changeactivateUser",
      "changePayStatus",
    ]),
    OpenImg(data) {
        console.log(data)
      window.open(data, "_blank");
    },
    SelectReport(data){
        this.selected = data
        this.$nextTick(() => {
        this.$bvModal.show("modal-report");
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getDataReports() {
        let type_id = 8
      this.isBusy = true;
      this.GetPaymentReports(type_id).then((response) => {
        if (response.code == 200) {
          this.ReportsTmp = response.data;
          this.totalRows = response.data.length;
          this.isBusy = false;
        }
      });
    },
    changeStatus(pay, stats) {
      let stat = stats === 2 ? "aprobar" : "rechazar";
      Swal.fire({
        title: "Atención",
        text: "¿Estás seguro que deseas " + stat + " este depósito?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#121419",
        showLoaderOnConfirm: true,
        confirmButtonText: 'Sí, seguro',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.progress = true
          let status =
            stats === 2
              ? "Se ha aceptado el depósito"
              : "Se ha rechazado el depósito";
          let form = {
            id: pay,
            status: stats,
          };
          Swal.showLoading();
          this.changePayStatus(form)
            .then((response) => {
              if (response.code === 200) {
          this.progress = false

                Swal.fire({
                  title: status,
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });
                this.getDataReports();
              }
            })
            .catch((error) => {
              console.log(error);
              alert("Ocurrió un error, intente más tarde");
              this.getDataReports();
            });
          console.log(form);
        }
      });
      
    },
    /* deletePaymentReport(data) {
      console.log(data)
      Swal.fire({
        title: "Atención",
        text:
          "¿Está seguro que desea eliminar el reporte de depósito de "+ data.name +"?",
        icon: "question",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#121419",
        confirmButtonText: "Sí, seguro",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.hide = true;
          let form = {
            user_id: data.id,
            status: "2",
          };

          Swal.showLoading();
          this.changePayStatus(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: status,
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });
                this.hide = false;
                this.getDataUser();
              }
            })
            .catch((error) => {
              console.log(error);
              this.hide = false;

              alert("Ocurrió un error, intente más tarde");
              this.getDataUser();
            });
        }
      });
    }, */
  },
};
</script>
<style scoped>
</style>